import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { UnroadworthyDefectsResponse } from 'src/app/models/unroadworthy-defects.model';
import { OpenAppointmentsResponse } from 'src/app/models/open-appointments.model';
import { MediaDetails } from 'src/app/models/media.model';
import { lastValueFrom } from 'rxjs';
import { OpenDefectInspection, OpenDefectInspectionMobile } from 'src/app/models/open-defects.model';
import { HttpContext } from '@angular/common/http';
import { SKIP_LOADER } from 'src/app/interceptors/auth/http-context-tokens';

@Injectable({
  providedIn: 'root',
})
export class UnroadworthyDefectsService {

  constructor(
    private readonly apiService: ApiService
  ) { }

  /**
   * Fetches unroadworthy / defect details for a vehicle.
   * This includes roadworthy status and open defect inspections.
   */
  getUnroadworthyDefects(icnNo: string) {
    return this.apiService.get<UnroadworthyDefectsResponse>(
      `UnroadworthyDefects/GetUnroadworthyDefectsDetails/${icnNo}`
    );
  }

  /**
   * Retrieves upcoming service appointments for a vehicle.
   */
  getOpenAppointments(icnNo: string) {
    return this.apiService.get<OpenAppointmentsResponse[]>(
      `service-booking/detail?icnNo=${icnNo}`
    );
  }

  /**
   * Fetches media (images/videos) associated with a specific defect.
   */
  getDefectMedia(id: string, icnNO: string) {
    return this.apiService.get<MediaDetails[]>(
      `GetMediaDefectsDetails`,
      `?vehInspectReportDetailId=${id}&icnNO=${icnNO}`,
      { context: new HttpContext().set(SKIP_LOADER, true) }
    );
  }

  /**
   * Process unroadworthy defects for an icnNo.
   */
  async processUnroadworthyDefects(icnNo: string) {
    const unroadworthyResponse: UnroadworthyDefectsResponse = await lastValueFrom(this.getUnroadworthyDefects(icnNo));
    return unroadworthyResponse;
  }

  /* Groups unrectified defects by inspection ID for mobile layout */
  groupUnrectifiedDefects(
    unrectifiedDefectsDetails: OpenDefectInspection[]
  ): OpenDefectInspectionMobile[] {
    const groupedDefects = unrectifiedDefectsDetails
      .filter(defect => !defect.defecT_RESOLVED_DATE)
      .reduce((acc: OpenDefectInspectionMobile[], defect) => {
        const existingGroup = acc.find(
          group =>
            group.shorT_INSPECTION_ID === defect.shorT_INSPECTION_ID
        );

        if (existingGroup) {
          existingGroup.defects.push(defect);
        } else {
          acc.push({
            shorT_INSPECTION_ID: defect.shorT_INSPECTION_ID,
            inspectioN_REPORT_DATE: defect.inspectioN_REPORT_DATE,
            defects: [defect],
          });
        }

        return acc;
      }, []);

    return groupedDefects;
  }
}
